import Modal from "@mui/material/Modal";
import {Slide} from "@mui/material";
import SystemBottomSheetClosingIcon from "../../../components/icons/SystemBottomSheetClosingIcon";
import {ClosingIconSize} from "../../../controllers/SystemBottomSheetClosingIconController";
import SystemCorrectionGhostTopBar from "../../../components/bars/SystemCorrectionGhostTopBar";
import FlashCorrectionContent from "../../../components/others/courses/flash/FlashCorrectionContent";

export default function FlashCorrectionScreen({open, handleClose, question, levelA}) {
    // Used in FlashResultsQuestionItem component to show single question
    // correction

    // BUILD
    return(
        <Modal open={open}
               onClose={handleClose}
               disableEnforceFocus>
            <Slide direction="up" in={open} mountOnEnter unmountOnExit>
                <div className="overflow-auto w-full h-[100svh] flex flex-col items-center justify-end outline-none">
                    <SystemCorrectionGhostTopBar handleClose={handleClose} />
                    <div className={"relative overflow-auto w-full grow flex flex-col items-center rounded-t-[32px]"}>
                        <SystemBottomSheetClosingIcon onPressed={handleClose}
                                                      closingIconSize={ClosingIconSize.MEDIUM} />
                        <FlashCorrectionContent question={question}
                                                levelA={levelA}/>
                    </div>
                </div>
            </Slide>
        </Modal>
    );
}